define('viewmodels/RaSocialization/Administration',['knockout', 'plugins/router', 'services/navigation', 'durandal/app', 'services/appsecurity', 'services/logger', 'durandal/system', 'viewmodels/survey/QuantitativeSurveySetup', 'services/utils', 'viewmodels/GeneralSettings'], function (ko, router, navigation, app, appsecurity, logger, system, QuantitativeSurveySetup, utils, ObjGeneralSettings) {
    var title = 'Survey Configuration';
    var ViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        detached: detached,
        utils: utils,
        ObjGeneralSettings: ObjGeneralSettings,
        BUTitle: ko.observable('Business Unit'),
        popUpTitleSurvey: ko.observable(),
        BuList: ko.observableArray([]),
        UsersList: ko.observableArray([]),
        ReviewerList: ko.observableArray([]),
        SurveyUsersList: ko.observableArray([]),
        BuIdList: ko.observableArray([]),
        AssignUsers: AssignUsers,
        RoleNameClick: RoleNameClick,
        SelectAllUsers: SelectAllUsers,
        SaveUserMapping: SaveUserMapping,
        LocaleCheckFlag: ko.observable(false),
        ViewSocializationPage: ViewSocializationPage,
        ResponseMoveArray: ko.observableArray([]),
        WorkFlowList: ko.observableArray([]),
        CurrentRoleType: ko.observable(),
        AssignmentLevelList: ko.observableArray(),
        AssignmentLevelSelected: ko.observable(),
        AssignmentLevelSelectedText: ko.observable(),
        BuListOrig: ko.observable(),
        AssignmentLevelChange: AssignmentLevelChange,
        AssignmentLevelChange: AssignmentLevelChange,
        ratList: ko.observableArray([]),
        selectedRat: ko.observable(),
        GetAllBusinessUnitsWithMapping: GetAllBusinessUnitsWithMapping,
        SelectedDeRatUid: ko.observable(),
        PossiblePushbackList: ko.observableArray([]),
        PushbackPopUpClick: PushbackPopUpClick,
        PushbackTheSurveyAjax: PushbackTheSurveyAjax,
        btnCloseActionPopup: btnCloseActionPopup,
        StatusPopUpClick: StatusPopUpClick,
        btnCloseStatusPopup: btnCloseStatusPopup,
        workflowModelList: ko.observableArray([]),
        ControlsAccess: ko.observable(false),
        SelectedSurveyLevelType: ko.observable(''),
        RoleId: ko.observable(),
        OpenConfigureDueDatePopupBulk: OpenConfigureDueDatePopupBulk,
        OpenConfigureDueDatePopup: OpenConfigureDueDatePopup,
        SaveDueDateGlobalFlag: ko.observable(1),
        DueDate: ko.observable(),
        SelectedSurveyName: ko.observable(),
        SelectedSurveyId: ko.observable(),
        CloseConfigureDueDatePopup: CloseConfigureDueDatePopup,
        SaveDueDate: SaveDueDate,
        SurveyComponentSelected: ko.observable(),
        SurveyTypesList: ko.observableArray([]),
        SelectedSurveyType: ko.observable(),
        SelectedSurveyTypeName: ko.observable(),
        SurComponentDrpDwn: ko.observable(),
        SelectAllBusinessUnits: SelectAllBusinessUnits,
        BuModelList: ko.observableArray([]),
        SelectedBuIdList: ko.observableArray([]),
    }

    return ViewModel;
    var TableObject;
    var Object = false;
    var TableObjectPopup;
    function activate() {
        try {
            if (ViewModel.ObjGeneralSettings === undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((ViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && ViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                ViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (ViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() == null || ViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || ViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || ViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        ViewModel.LocaleCheckFlag(false);
                    else
                        ViewModel.LocaleCheckFlag(true);
                });
            }

            ViewModel.BUTitle((ViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() == null || ViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || ViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || ViewModel.ObjGeneralSettings.LocalizedIndexList() == null || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in Administration.js';
            logger.logMessage(msg);
        }
    };

    function detached() {
        try {

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in Administration.js';
            logger.logMessage(msg);
        }
    };

    function attached() {
        try {
            appsecurity.SocializationReadOnly(true);
            //GetAllBusinessUnitsWithMapping();
            GetallSurveyUsers();

            appsecurity.WriteAccess(false);
            ko.utils.arrayFilter(appsecurity.userInfo().moduleList(), function (arr) {
                if (arr.ModuleCodeName() == "RaSocialization") {
                    ko.utils.arrayFilter(arr.PageList(), function (arrInner) {
                        if (arrInner.PageCodeName() === "RASAdministration" && (arrInner.WriteAccess())) {
                            appsecurity.WriteAccess(true);
                            return true;
                        }
                    });
                }
            });

            if (appsecurity.isConfigurationFreeze() === undefined) {
                appsecurity.GetConfigurationFreezeFlag().then(function () {
                    if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                        ViewModel.ControlsAccess(true);
                    }
                    else {
                        ViewModel.ControlsAccess(false);
                    }
                });
            }
            else if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                ViewModel.ControlsAccess(true);
            }
            else {
                ViewModel.ControlsAccess(false);
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in Administration.js';
            logger.logMessage(msg);
        }
    }


    function GetAllBusinessUnitsWithMapping(data) {
        try {
            $('#NoBUError').hide()
            if (data)
                ViewModel.selectedRat(data.ratUID);

            $('.nav-tabs-custom').children().children().removeClass('active');

            event.currentTarget.className = 'active';

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/GetAssignmentMapping?ratUid=" + ViewModel.selectedRat(),
                headers: headers,
                type: "GET",
            })
                .success(function (jsonResult, Success) {
                    ViewModel.BuList([]);
                    if (jsonResult.ErrorId == -99) {
                        logger.logError(jsonResult.ErrorCode + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);
                    }
                    else {
                        if (jsonResult.businessLevel.length != null && jsonResult.businessLevel.length > 0) {
                            ViewModel.AssignmentLevelList(jsonResult.businessLevel);
                            for (var i = 0; i < jsonResult.businessLevel.length; i++) {
                                if (ViewModel.AssignmentLevelList()[i].BlDefaultSelected == true) {
                                    ViewModel.AssignmentLevelSelected(ViewModel.AssignmentLevelList()[i].BlId);
                                }
                            }
                            if (ViewModel.SelectedSurveyLevelType() != undefined || ViewModel.SelectedSurveyLevelType() != '') {
                                ViewModel.AssignmentLevelSelected(ViewModel.SelectedSurveyLevelType());
                            }
                        }
                        if (jsonResult != null && jsonResult.length != 0) {
                            ViewModel.BuListOrig(jsonResult.businessUnitModel);
                            var BuModelObj = new BusinessUnitModel(jsonResult.businessUnitModel);
                            ViewModel.BuModelList(jsonResult.businessUnitModel);
                            AssignmentLevelChange();
                        }
                        else {
                            $('#NoBUError').show();
                            $('#contentDiv').hide();
                        }
                        $('#Select_ALL_Business_Units').prop('checked', false);
                    }
                })
                .fail(function (status, error) {

                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllBusinessUnitsWithMapping() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function AssignmentLevelChange() {
        try {
        $('#Select_ALL_Business_Units').prop('checked', false);
        var table = $("#AdminTab").dataTable();
        table.fnDestroy();
        $("#AdminTab tbody tr").remove();

        $('#contentDiv').show();
        $('#AdminTab').show();
        if (ViewModel.BuListOrig() != null && ViewModel.BuListOrig().length != 0) {
            var MappedList = $.map(ViewModel.BuListOrig(), function (item) {
                if (ViewModel.AssignmentLevelSelected() == item.BlId)
                    return new BusinessUnitModel(item);
            });
            for (var i = 0; i < ViewModel.AssignmentLevelList().length; i++) {
                if (ViewModel.AssignmentLevelList()[i].BlId == ViewModel.AssignmentLevelSelected()) {
                    ViewModel.AssignmentLevelSelectedText(ViewModel.AssignmentLevelList()[i].BlName);
                    ViewModel.SelectedSurveyLevelType(ViewModel.AssignmentLevelList()[i].BlId);
                    break;
                }
            }
         //   OLTableObj = $('#AdminTab').DataTable();
         //   var p = OLTableObj.page.info().page
           // OLTableObj.destroy();
         //   $("#AdminTab tbody tr").remove();
            ViewModel.BuList(MappedList);
            OLTableObj = $('#AdminTab').DataTable({
                stateSave: true,
                "aoColumnDefs": [{
                    "aTargets": [1],
                    "order": [],
                    "bSortable": false
                }]
            });
          //  OLTableObj.page(p).draw(false);
            $('#contentDiv').show(1000);

            var rows = $("#AdminTab").dataTable().fnGetNodes();
            var cells = [];
            for (var i = 0; i < rows.length; i++) {
                // Get HTML of 3rd column (for example)
                var RespText = $(rows[i]).find("td:eq(1)").html()
                var RespTextEdit = RespText.replace(/}/g, '<br/>');
                $(rows[i]).find("td:eq(1)").html(RespTextEdit);
                if ($(rows[i]).find("td:eq(1)").text().toUpperCase() == 'UNASSIGNED') {
                    if ($(rows[i]).find("td:eq(1)") != null && $(rows[i]).find("td:eq(3)") != undefined) {
                        $(rows[i]).find("td:eq(1)").css('color', '#FF0000');
                    }
                }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssignmentLevelChange() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function SaveUserMapping(data, event) {
        try {
            SaveMapping(GetSaveJson())
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveUserMapping() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function GetSaveJson(List) {
        try {
            var MappedUserList = [];
            for (var k = 0; k < ViewModel.BuIdList().length; k++) {
                for (var i = 0; i < ViewModel.SurveyUsersList().length; i++) {
                    if (ViewModel.SurveyUsersList()[i].IsChecked()) {
                        var Object = { BusinessUnitID: ViewModel.BuIdList()[k], RoleType: ViewModel.SurveyUsersList()[i].RoleType(), RoleID: ViewModel.SurveyUsersList()[i].RoleID(), UserId: ViewModel.SurveyUsersList()[i].UserID() };

                        MappedUserList.push(Object)
                    }
                }
            }
            return MappedUserList;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetSaveJson() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function SaveMapping(MappedUserList) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/SaveBUSurveyMapping?Buid=" + ViewModel.BuIdList() + "&RoleType=" + ViewModel.CurrentRoleType(),
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(MappedUserList)
            })
                .success(function (jsonResult, success) {
                    if (jsonResult != null) {
                        if (isNaN(jsonResult)) {
                            logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);
                        }
                        else if (!isNaN(jsonResult) && parseInt(jsonResult) > 0) {
                            logger.logSuccess('Mapping Saved Successfully.', 'Success', system.getModuleId(ViewModel), true);
                            for (var i = 0; i < ViewModel.WorkFlowList().length; i++) {
                                if (ViewModel.WorkFlowList()[i].RoleShrtName() == ViewModel.CurrentRoleType()) {
                                    if (parseInt(jsonResult) > 0)
                                        ViewModel.WorkFlowList()[i].UserSelected(true);
                                    else
                                        ViewModel.WorkFlowList()[i].UserSelected(false);
                                    break;
                                }
                            }
                            GetAllBusinessUnitsWithMapping();
                        }
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);
                    }
                })
                .fail(function (status, error) {

                })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveMapping() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function GetallSurveyUsers() {
        try {
            //GetResponderReviewerDetails
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/GetResponderReviewerRATDetails",
                headers: headers,
                type: "GET",
            })
                .success(function (jsonResult, Success) {
                    if (jsonResult.ErrorId == -99) {
                        logger.logError(jsonResult.ErrorCode + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);
                    }
                    else {
                        if (jsonResult.surveyUsersList != null && jsonResult.surveyUsersList.length != 0)
                            var MappedListResp = $.map(jsonResult.surveyUsersList, function (item) {
                                return new SurveyUserModel(item);
                            })
                        ViewModel.UsersList(MappedListResp);
                        if (jsonResult.ratList != null && jsonResult.ratList.length != 0) {
                            ViewModel.ratList(jsonResult.ratList);
                            $('#adddivTabs').tabs();
                            $('#adddivTabs').tabs('refresh');
                            $('#adddivTabs').tabs({ active: 0 });
                            $("#InherentTabDiv").removeClass('ui-widget-content');
                            $("#tabContent").removeClass('ui-widget-content');
                            $($('#SurveyCategoryTabsDiv li').get(0)).trigger('click');
                            $($('#SurveyCategoryTabsDiv li').get(0)).addClass('active');
                        }
                    }
                })
                .fail(function (status, error) { })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetallSurveyUsers() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function RoleNameClick(data, event) {
        try {
            var Object = $("#MappingTable").DataTable();
            Object.destroy();
            $("#MappingTable tbody tr").remove();

            // var ClickedUserIdList = ViewModel.BuList().filter(item => item.BuId() === ViewModel.BuIdList()[0])[0].UserIdList();
            var ClickedUserIdList = ViewModel.BuList().filter(function (n) { return (n.BuId() === ViewModel.BuIdList()[0]) })[0].UserIdList();

            //  var ClickedRoleTypeList = ViewModel.BuList().filter(item => item.BuId() === ViewModel.BuIdList()[0])[0].RoleTypeList();
            var ClickedRoleTypeList = ViewModel.BuList().filter(function (n) { return n.BuId() === ViewModel.BuIdList()[0] })[0].RoleTypeList();
            ViewModel.CurrentRoleType(data.RoleShrtName());
            ViewModel.SurveyUsersList([]);

            var MappedList = [];
            if (ViewModel.UsersList() != undefined) {
                 MappedList = $.map(ViewModel.UsersList(), function (item) {
                    return new SurveyUserMappingModel(item);
                })
            }

            if (ClickedUserIdList.length > 0 && ClickedUserIdList.toLowerCase() != 'unassigned') {
                var aray = ClickedUserIdList.split('}');
                var aray2 = ClickedRoleTypeList.split('}');
                for (var i = 0; i < aray.length; i++) {
                    for (var k = 0; k < MappedList.length; k++) {
                        if ((parseInt(aray[i]) == MappedList[k].UserID()) && ((MappedList[k].RoleType().trim()) === (aray2[i].trim()))) {
                            MappedList[k].IsChecked(true);
                            break;
                        }
                    }
                }
            }
            if (ViewModel.CurrentRoleType() != 'ASSIGNED_USER_LIST') {
                // ViewModel.SurveyUsersList(MappedList.filter(item => item.RoleType() === ViewModel.CurrentRoleType()));
                ViewModel.SurveyUsersList(MappedList.filter(
                    function (n) { return n.RoleType() === ViewModel.CurrentRoleType() }));
            }
            else {
                //   ViewModel.SurveyUsersList(MappedList.filter(item => item.IsChecked() === true ));
                ViewModel.SurveyUsersList(MappedList.filter(
                    function (n) {
                        return n.IsChecked() === true
                    }));
            }

            $('#MappingTable').DataTable();
            $('#selectallUsers').prop('checked', false);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RoleNameClick() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function AssignUsers(data, event) {
        try {
            ViewModel.BuIdList([])
            ViewModel.BuIdList().push(data.BuId())

            ViewModel.popUpTitleSurvey('Assign Users for ' + data.BusinessUnitName())
            //$('#SurveyAssignment').modal('show');
            var Object = $("#MappingTable").DataTable();
            Object.destroy();
            $("#MappingTable tbody tr").remove();


            //get the names of different roles.
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/GetWorkFlowRoles?DE_UID=" + ViewModel.BuIdList(),
                headers: headers,
                type: "GET",
            })
                .success(function (jsonResult, Success) {
                    if (jsonResult != null && jsonResult[0].ErrorId == -99) {
                        logger.logError(jsonResult[0].ErrorCode + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);
                    }
                    else if (jsonResult != null && jsonResult.length != 0) {
                        var MappedListWorkFlow = $.map(jsonResult, function (item) {
                            return new WorkFlowModel(item);
                        })
                        ViewModel.WorkFlowList(MappedListWorkFlow);
                        ViewModel.CurrentRoleType(ViewModel.WorkFlowList()[0].RoleShrtName());
                        var MappedList = [];
                        if (ViewModel.UsersList() != undefined) {
                            MappedList = $.map(ViewModel.UsersList(), function (item) {
                                return new SurveyUserMappingModel(item);
                            })
                        }
                        ViewModel.SurveyUsersList([]);
                        if (data.UserIdList().length > 0 && data.UserIdList().toLowerCase() != 'unassigned') {
                            var aray = data.UserIdList().split('}');
                            var aray2 = data.RoleTypeList().split('}');
                            for (var i = 0; i < aray.length; i++) {
                                for (var k = 0; k < MappedList.length; k++) {
                                    if ((parseInt(aray[i]) == MappedList[k].UserID()) && (MappedList[k].RoleType().trim()) === (aray2[i].trim())) {
                                        MappedList[k].IsChecked(true);
                                        break;
                                    }
                                }
                            }
                        }
                        if (ViewModel.CurrentRoleType() != 'ASSIGNED_USER_LIST') {
                      //      ViewModel.SurveyUsersList(MappedList.filter(item => item.RoleType() === ViewModel.CurrentRoleType()));
                            ViewModel.SurveyUsersList(MappedList.filter(
                                function (n) {
                                    return  n.RoleType() === ViewModel.CurrentRoleType()
                                }));
                        }
                        else {
                            ViewModel.SurveyUsersList(MappedList.filter(
                                function (n) {
                                return   n.IsChecked() === true
                                }));
                        }
                        $('#MappingTable').DataTable();
                        $('#selectallUsers').prop('checked', false);
                        $('#SurveyAssignment').modal('show');
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);
                    }
                })
                .fail(function (status, error) { })

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssignUsers() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function StatusPopUpClick(data, event) {
        try {
            $('#SocializationStatusPopUp').modal('show');
            $('#loadingImgMainRC2').show();
            ViewModel.SelectedDeRatUid(data.BuId());
            GetRoleUserDetailsForBU();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in StatusPopUpClick in Administration.js';
            logger.logMessage(msg);
        }
    }

    function btnCloseStatusPopup() {
        try {
            $('#SocializationStatusPopUp').modal('hide');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in btnCloseActionPopup in Administration.js';
            logger.logMessage(msg);
        }
    }

    function GetRoleUserDetailsForBU() {
        try {
            $.ajax({
                url: "/api/Configuration/GetRoleUserDetailsForBU",
                data: {
                    "BuId": ViewModel.SelectedDeRatUid(),
                },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, success) {
                    $('#loadingImgMainRC2').hide();
                    ViewModel.workflowModelList([]);
                    if (jsonResult.length > 0 && jsonResult != null) {
                        if (jsonResult[0].RoleID == -99) {
                            logger.logError(jsonResult[0].RoleName + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);
                        }
                        else
                            ViewModel.workflowModelList(jsonResult);
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);
                    }
                })
                .fail(function (error, fail) { });
            $('#loadingImgMainRC2').hide();
        }
        catch (e) {
            $('#loadingImgMainRC2').hide();
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetRoleUserDetailsForBU() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function PushbackPopUpClick(data, event) {
        try {
            //if (!(data.WfChangeFlag())) {
                $('#ActionsPopUp').modal('show');
                Pushback(data, event);
            //}
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in PushbackPopUpClick in Administration.js';
            logger.logMessage(msg);
        }
    }

    function Pushback(data, event) {
        try {
            ViewModel.SelectedDeRatUid(data.BuId());
            $.ajax({
                url: "/api/Survey/GetPossiblePushbackListSocialization",
                data: { DeRatUid: data.BuId() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in Pushback() method in Administration.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                $('#ActionsMain').hide();
                $('#loadingImgMainRC1').hide();
                ViewModel.PossiblePushbackList([]);
                if (jsonResult != null) {
                    if (jsonResult.length != 0 && jsonResult[0].EVENT_ID == -99) {
                        logger.logError(jsonResult[0].EVENT_NAME + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);
                    }
                    else {
                        var mappedActionsList = $.map(jsonResult, function (result) {
                            return new PushBackModel(result);
                        });
                        ViewModel.PossiblePushbackList(mappedActionsList);
                    }
                }
                else {
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);
                }
                $('#ActionsMain').show();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in Pushback() method in Administration.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in Pushback() method in Administration.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in Pushback() method in Administration.js';
                logger.logMessage(msg);
            }
        };
    }

    function PushbackTheSurveyAjax(data, event) {
        try {
            var EventId = 0;
            EventId = $("input[name='rdbAction']:checked").val();
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Survey/PushbackSocializationSurvey?EventId=" + EventId + "&DeRatUid=" + ViewModel.SelectedDeRatUid(),
                headers: headers,
                type: "POST"
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception' + e + ' || source: ajax call in PushbackTheSurveyAjax() in Administration.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult .length != 0 && jsonResult[0].ErrorId == -99) {
                        logger.logError(jsonResult[0].ErrorCode + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);
                    }
                    else if (jsonResult[0].Flag == 0) {
                        logger.logSuccess('The socialization survey has been pushed back successfully.', 'Success', system.getModuleId(ViewModel), true);
                        $('#ActionsPopUp').modal('hide');
                    }
                    else
                        logger.logError('An error occurred while pushing back the socialization survey.', 'Error', system.getModuleId(ViewModel), true);
                }
                else {
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' || source:  ajaxSuccess() in PushbackTheSurveyAjax() in Administration.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' || Source: ajaxFail in PushbackTheSurveyAjax() method in Administration.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var mes = 'Exception: ' + e + ' | Source: ajaxFail in PushbackTheSurveyAjax() method in Administration.js';
                logger.logMessage(mes);
            }
        }
    }

    function btnCloseActionPopup() {
        try {
            $('#ActionsPopUp').modal('hide');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in btnCloseActionPopup in Administration.js';
            logger.logMessage(msg);
        }
    }

    function PushBackModel(item) {
        try {
            var self = this;
            self.EVENT_ID = ko.observable($('<div/>').html(item.EVENT_ID).text());
            self.EVENT_NAME = ko.observable($('<div/>').html(item.EVENT_NAME).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: PushBackModel() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function BusinessUnitModel(item) {
        try {
            var self = this;
            self.BuId = ko.observable(item.BuId);
            self.BuDueDate = ko.observable(item.DueDate);
            self.BlId = ko.observable(item.BlId);
            self.BusinessUnitName = ko.observable($('<div/>').html(item.BusinessUnitName).text());
            self.isChecked = ko.observable(false);
            if (item.UserList.length == "")
                self.UserList = ko.observable("UNASSIGNED");
            else
                self.UserList = ko.observable(item.UserList);

            self.Status = ko.observable(item.BuStatus)
            if (item.BuStatus.toLowerCase() == 'completed')
                self.MainListColourCode = ko.observable("#012169")
            else
                self.MainListColourCode = ko.observable("#97999B")

            self.ScStatus = ko.observable(item.SocializationStatus)
            if (item.SocializationStatus.toLowerCase() == 'completed')
                self.ScListColourCode = ko.observable("#012169");
            else if (item.SocializationStatus.toLowerCase() == 'not launched')
                self.ScListColourCode = ko.observable("#97999B");
            else
                self.ScListColourCode = ko.observable("#007cb0");

            self.SurveyName = ko.observable(item.SurveyName);
            self.IsCompletedFlag = ko.observable(item.IsCompletedFlag);
            self.DueDate = ko.observable(item.DueDate);
            self.SurveyStatus = ko.observable(item.SurveyStatus);
            self.PendingWith = ko.observable(item.PendingWith);
            self.SurveyType = ko.observable(item.SurveyType);

            // logic to add html part and modifications to RG Name and BUList attributes on Survey Card
            var rgName = item.ProfileName;
            var rgString = "";
            if (rgName != null || rgName != "") {
                var RGSplit = rgName.toString().split("class='bu-val'>");
                rgString = RGSplit[0] + " class='bu-val' title='" + RGSplit[1].split("</span></span>")[0].toString().trim() + "'>" + RGSplit[1];
            }


            var BUList = item.BUList;
            var BUlistStringHTML = "";
            if (BUList != null || BUList != "") {
                var BUListSplit = BUList.toString().split("<span class='bu-lbl'><strong class='lbl-space'>");
                for (var n = 1; n < BUListSplit.length; n++) {
                    var BUListSplitInner = BUListSplit[n].toString().split(":</strong><span class='bu-val'>");
                    BUlistStringHTML += "<span class='bu-lbl'><strong class='lbl-space'>" + BUListSplitInner[0] + ":</strong><span class='bu-val' title='" + BUListSplitInner[1].split("</span></span>")[0].toString().trim() + "'>" + BUListSplitInner[1];
                }
            }

            self.ProfileName = ko.observable(rgString);
            self.BUList = ko.observable(BUlistStringHTML);
            self.SurveyIconClass = ko.observable(item.SurveyIconClass);
            self.SurveyStateColor = ko.observable(item.SurveyStateColor);
            self.SurveyStateName = ko.observable(item.SurveyStateName);

            self.UserIdList = ko.observable(item.UserIdList);
            self.RoleTypeList = ko.observable(item.RoleTypeList);
            self.ScLaunchFlag = ko.observable(item.ScLaunchFlag == 0 ? false : true);
            self.WfChangeFlag = ko.observable(item.WfChangeFlag == 0 ? true : false);
            //if (item.ScLaunchFlag == 0) {
            //    self.ScLaunchFlag = false;
            //} else {
            //    self.ScLaunchFlag = true;
            //}
            self.RiskConfigType = ko.observable(item.RiskConfigType);
            self.LaunchSocializationBu = function (data, event) {
                if (data.ScLaunchFlag() != true) {
                    app.showMessage('Are you sure you want to launch socialization ?', 'Launch Socialization', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus confirmCheck", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-chevron-right text-default' })
                        .then(function (option) {
                            if (option === 'Confirm') {
                                try {
                                    var BuId = data.BuId();
                                    var headers = appsecurity.getSecurityHeaders();

                                    $.ajax({
                                        url: "/api/Configuration/LaunchSocializationPerBU?BuId=" + BuId,
                                        headers: headers,
                                        type: "GET"
                                    })
                                        .success(function (jsonResult, success) {
                                            if (jsonResult != null) {
                                                if (isNaN(jsonResult)) {
                                                    logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(ViewModel), true);
                                                }
                                                else if (!isNaN(jsonResult) && parseInt(jsonResult) > 0) {
                                                    logger.logSuccess('Socialization survey launched successfully.', 'Success', system.getModuleId(ViewModel), true);
                                                    GetAllBusinessUnitsWithMapping();
                                                }
                                            } else {
                                                logger.logError('An error occurred. Please contact your application administrator.', 'Error', system.getModuleId(ViewModel), true);
                                            }
                                        })
                                        .fail(function (status, error) {
                                            logger.logError('An error occurred. Please contact your application administrator.', 'Error', system.getModuleId(ViewModel), true);
                                        })

                                } catch (e) {
                                    logger.logError('An error occurred. Please contact your application administrator.', 'Error', system.getModuleId(ViewModel), true);
                                    var msg = 'Exception: ' + e + ' | Source: LaunchSocializationBu() method in Administration.js';
                                    logger.logMessage(msg);
                                }
                            }
                        });
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnitModel() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function SelectAllUsers(data, event) {
        try {
            //  var rows = $("#MappingTable").dataTable().fnGetNodes();
            // var cells = [];
            for (var i = 0; i < ViewModel.SurveyUsersList().length; i++) {
                if (event.currentTarget.checked == true) {
                    //$(rows[i]).find("td:eq(1)").find('input').prop("checked", true);
                    ViewModel.SurveyUsersList()[i].IsChecked(event.currentTarget.checked);
                }
                else {
                    // $(rows[i]).find("td:eq(1)").find('input').prop("checked", false);
                    ViewModel.SurveyUsersList()[i].IsChecked(false);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectAllUsers() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function ViewSocializationPage(data) {
        try {

            appsecurity.SocializationReadOnly(true);
            var BuId = data.BuId();
            var BuName = data.BusinessUnitName();
            var UserList = data.UserList().replace(/}/g, ' |');

            var socType = 'Normal';
            if (data.BlId() == -1001)
                socType = 'Overall';

            ViewModel.ResponseMoveArray(new ResponseMoveModel({
                BusinessUnitId: BuId,
                BusinessUnitName: BuName,
                ReadOnly_FLAG: true,
                RatId: ViewModel.selectedRat(),
                SurveyName: data.SurveyName(),
                SurveyId: BuId,
                DueDate: data.DueDate(),
                SurveyStatus: data.SurveyStatus(),
                PendingWith: data.PendingWith(),
                SurveyIconClass: data.SurveyIconClass(),
                SurveyStateColor: data.SurveyStateColor(),
                SurveyStateName: data.SurveyStateName(),
                UserList: UserList,
                BUList: data.BUList(),
                AssessmentType: data.RiskConfigType(),// 2 = CRA and 1 = AML/OFAC
                SocType: socType,
                CurrentProfileOfAssessmentId: ViewModel.appsecurity.CurrentProfileOfAssessmentId(),
                IsCompletedFlag: data.IsCompletedFlag(),
                SurveyType: data.SurveyType(),
                ProfileName: data.ProfileName(),
                SurveyClassification: 'SOC'

            }));
            router.navigate("#RaSocialization/SocializationResponse", true);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ViewSocializationPage() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function ResponseMoveModel(item) {
        try {
            var self = this;
            self.SurveyProfileId = ko.observable(item.SurveyProfileId);
            self.SurveyTypeId = ko.observable(item.SurveyTypeId);
            self.PageHeaderName = ko.observable(item.PageHeaderName);
            self.BusinessUnitId = ko.observable(item.BusinessUnitId);
            self.BusinessUnitName = ko.observable(item.BusinessUnitName);
            self.SurveyType = ko.observable(item.SurveyType);
            self.SurveyId = ko.observable(item.SurveyId);
            self.SurveyStatus = ko.observable(item.SurveyStatus);
            self.ReadOnly_FLAG = ko.observable(item.ReadOnly_FLAG);
            self.RatId = ko.observable(item.RatId);
            self.SurveyClassification = ko.observable(item.SurveyClassification);
            self.SurveyName = ko.observable(item.SurveyName);
            self.SurveyIconClass = ko.observable(item.SurveyIconClass);
            self.SurveyStateName = ko.observable(item.SurveyStateName);
            self.DueDate = ko.observable(item.DueDate);
            self.PendingWith = ko.observable(item.PendingWith);
            self.SurveyStateColor = ko.observable(item.SurveyStateColor);
            self.UserList = ko.observable(item.UserList);
            self.BUList = ko.observable(item.BUList);
            self.AssessmentType = ko.observable(item.AssessmentType);
            self.SocType = ko.observable(item.SocType);
            self.CurrentProfileOfAssessmentId = ko.observable(item.CurrentProfileOfAssessmentId);
            self.IsCompletedFlag = ko.observable(item.IsCompletedFlag);
            self.ProfileName = ko.observable(item.ProfileName);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: ResponseMoveModel() in Administration.js';
            logger.logMessage(msg);
        }
    }

    function SurveyUserMappingModel(item) {
        try {
            var self = this;
            self.UserID = ko.observable(item.UserID());
            self.RoleID = ko.observable(item.RoleID());
            self.UserName = ko.observable(item.UserName());
            self.RoleName = ko.observable(item.RoleName());
            self.RoleType = ko.observable(item.RoleType());
            self.IsChecked = ko.observable(false);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyUserMappingModel() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function SurveyUserModel(item) {
        try {
            var self = this;
            self.UserID = ko.observable(item.UserID);
            self.RoleID = ko.observable(item.RoleID);
            self.UserName = ko.observable(item.UserName);
            self.RoleType = ko.observable(item.RoleType);
            self.RoleName = ko.observable(item.RoleName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyUserModel() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function WorkFlowModel(item) {
        try {
            var self = this;
            self.RoleShrtName = ko.observable(item.RoleShrtName);
            self.RoleName = ko.observable(item.RoleName);
            self.UserSelected = ko.observable(item.UserSelected);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: WorkFlowModel() method in Administration.js';
            logger.logMessage(msg);
        }
    }

    function OpenConfigureDueDatePopupBulk() {
        console.log(ViewModel.BuList());
        ViewModel.SelectedBuIdList([]);
        for (var i = 0; i < ViewModel.BuList().length; i++) {
            if (ViewModel.BuList()[i].isChecked()) {
                ViewModel.SelectedBuIdList().push(ViewModel.BuList()[i].BuId());
            }
        }
        if (ViewModel.SelectedBuIdList().length > 0)
            ViewModel.SaveDueDateGlobalFlag(2); // 2-for Bulk Action
        else
            ViewModel.SaveDueDateGlobalFlag(1); // Global Configuration

        ViewModel.DueDate("");
        $('#DueDate').datepicker({ dateFormat: 'MM dd yy', changeMonth: true, changeYear: true });
        $('#DueDateConfigurePopUp').modal('show');
    }
    function OpenConfigureDueDatePopup(data, event) {
        ViewModel.SaveDueDateGlobalFlag(0);
        ViewModel.SelectedBuIdList([]);
        ViewModel.DueDate(data.BuDueDate());
        ViewModel.SelectedSurveyName(data.BusinessUnitName());
        ViewModel.SelectedSurveyId(data.BuId());
        $('#DueDate').datepicker({ dateFormat: 'MM dd yy', changeMonth: true, changeYear: true });
        $('#DueDateConfigurePopUp').modal('show');
    }
    function CloseConfigureDueDatePopup() {
        $('#DueDateConfigurePopUp').modal('hide');
    }

    function SaveDueDate(data, event) {
        // We will pass BU Id and SP Uid for individual surveys
        try {
            var BusinessUnitId = "";
            var BuIds = "";
            var SelectedBuIds = "";

            for (var i = 0; i < ViewModel.SelectedBuIdList().length; i++) {
                BuIds += ViewModel.SelectedBuIdList()[i];
                BuIds += ",";
            }

            if (BuIds.length > 0)
                SelectedBuIds = BuIds.slice(0, -1);// To remove one extra comma inserted

            if (ViewModel.SelectedBuIdList().length > 0) {
                BusinessUnitId = SelectedBuIds;
                ViewModel.SaveDueDateGlobalFlag(2); // To recognize bulk option
            }
            else if (ViewModel.SelectedSurveyId())
                BusinessUnitId = ViewModel.SelectedSurveyId();

            var SelectedRatId = ViewModel.selectedRat();

            if (!((new Date(data.DueDate()) !== "Invalid Date") && !isNaN(new Date(data.DueDate())))) {
                logger.logError((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidDateAlert') == -1) ? 'Please enter a valid Date.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidDateAlert')].Name(), 'Error', system.getModuleId(ViewModel), true);
            }
            else {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/configuration/SetRaSocializationDueDate",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        GlobalFlag: ViewModel.SaveDueDateGlobalFlag(),
                        SelectedDeratId: BusinessUnitId,
                        AssignmentLevelSelected: ViewModel.AssignmentLevelSelected(),
                        SelectedRatId: SelectedRatId,
                        DueDate: data.DueDate()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);


               
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveDueDate() method in Administration.js';
            logger.logMessage(msg);
        }


        function ajaxSuccess(jsonResult, status) {
            try {
                var code = jsonResult.substring(0, 2);
                var msg = jsonResult.substring(2, 13);
                if (parseInt(jsonResult) > 0) {
                    logger.logSuccess((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DueDateSuccessMsg') == -1) ? 'Due Date has been saved successfully.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DueDateSuccessMsg')].Name(), 'Success', system.getModuleId(ViewModel), true);
                    GetAllBusinessUnitsWithMapping();
                }
                else if (code == '-2') {
                    logger.logError((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyNotConfiguredMsg') == -1) ? msg + " - " + 'Selected survey has not been configured..' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SurveyNotConfiguredMsg')].Name(), 'Error', system.getModuleId(ViewModel), true);
                }
                else {
                    logger.logError(jsonResult + " - " + 'An error has occurred whie saving the Due Date. Please contact your Administrator.', 'Error', system.getModuleId(ViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveDueDate() method in Administration.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!SCViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Application Error' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveDueDate() method in Administration.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in SaveDueDate() method in Administration.js';
                logger.logMessage(msg);
            }
        };
    }

    function SelectAllBusinessUnits(data, event) {
        try {
            if (event.currentTarget.checked) {
                for (var i = 0; i < ViewModel.BuList().length; i++) {
                    ViewModel.BuList()[i].isChecked(event.currentTarget.checked);
                }
            }
            else {

                for (var i = 0; i < ViewModel.BuList().length; i++) {
                    ViewModel.BuList()[i].isChecked(event.currentTarget.checked);
                }
            }
            var rows = $("#AdminTab").dataTable().fnGetNodes();
            //$("#AdminTab").removeClass("border-collpase")
            var cells = [];
            for (var i = 0; i < rows.length; i++) {
                if (event.currentTarget.checked == true)
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", true);
                else
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", false);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectAllBusinessUnits() method in Administration.js';
            logger.logMessage(msg);
        }
    }


});
